module.exports = __webpack_public_path__ + "static/media/asc-checkmark.401b04ad.svg";